'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRule$002dName$0024 from "./presto.types$-Rule-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_RulesTable$$anon$4() {
}
export { $c_Lpresto_RulesTable$$anon$4 as $c_Lpresto_RulesTable$$anon$4 };
$p = $c_Lpresto_RulesTable$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RulesTable$$anon$4;
/** @constructor */
function $h_Lpresto_RulesTable$$anon$4() {
}
export { $h_Lpresto_RulesTable$$anon$4 as $h_Lpresto_RulesTable$$anon$4 };
$h_Lpresto_RulesTable$$anon$4.prototype = $p;
$p.bh = (function(_$36) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$36, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$37) => _$37.n7)), $j_presto$002etypes$0024$002dRule$002dName$0024.$m_Lpresto_types$RuleName$().ct4());
});
var $d_Lpresto_RulesTable$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RulesTable$$anon$4, "presto.RulesTable$$anon$4", ({
  Qv: 1,
  H: 1
}));
export { $d_Lpresto_RulesTable$$anon$4 as $d_Lpresto_RulesTable$$anon$4 };
//# sourceMappingURL=presto.-Rules-Table$$anon$4.js.map
